import axios from 'axios';

// The signed-in person's display preferences (default ticket view, order per
// status, language of summaries) — stored on their own account by the
// backend (/api/users/preferences), read once per page load.

export const ORDER_ALL = 'all';
export const SUMMARY_LANGUAGES = ['fr', 'en', 'es', 'de', 'it', 'pt', 'nl', 'zh'];

const EMPTY = { default_view_id: null, ticket_order: {}, summary_language: null };
let cached = null;

const authHeaders = () => {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchPreferences = () => {
  if (!cached) {
    cached = axios.get('/api/users/preferences', { headers: authHeaders() })
      .then((response) => ({ ...EMPTY, ...(response.data || {}) }))
      .catch(() => {
        cached = null; // retried on the next read
        return { ...EMPTY };
      });
  }
  return cached;
};

export const savePreferences = async (update) => {
  const response = await axios.put('/api/users/preferences', update, { headers: authHeaders() });
  const saved = { ...EMPTY, ...(response.data || {}) };
  cached = Promise.resolve(saved);
  return saved;
};

// The order a list showing `statusKey` (a status, or ORDER_ALL) is displayed
// in: the person's choice for that status, else their « all statuses »
// choice, else most recently updated first.
export const orderFor = (preferences, statusKey) => {
  const order = preferences?.ticket_order || {};
  return order[statusKey || ORDER_ALL] || order[ORDER_ALL] || 'desc';
};
